'use strict';

import {parseUnixWithMilliSeconds} from "../shared/utils";

class ContactFormSubmission {
    constructor(data) {
        if (data === undefined) {
            return;
        }
        this.refresh(data);
    }

    refresh(data = this) {
        this.dbo = data;

        // API strips the cfs_ prefix, so fields come without it
        this.id = this.dbo['id_contact_form_submission'];
        this.name = this.dbo['name'];
        this.email = this.dbo['email'];
        this.phone = this.dbo['phone'];
        // Quote request specific fields
        this.quoteType = this.dbo['quote_type'];
        this.eventType = this.dbo['event_type'];
        this.eventDate = this.dbo['event_date'];
        this.eventLocation = this.dbo['event_location'];
        this.expectedGuests = this.dbo['expected_guests'] ? parseInt(this.dbo['expected_guests']) : null;
        this.additionalNotes = this.dbo['additional_notes'];
        this.referralSource = this.dbo['referral_source'];
        
        // Message: use additionalNotes if filled, otherwise use message field
        this.message = this.additionalNotes || this.dbo['message'];
        
        this.termsAccepted = this.dbo['terms_accepted'] === "1";
        this.submissionDate = this.dbo['submission_date'];
        this.submissionTime = this.dbo['submission_time'];
        this.pageUrl = this.dbo['page_url'];
        this.formId = this.dbo['form_id'];
        this.formName = this.dbo['form_name'];
        this.createdAt = parseUnixWithMilliSeconds(this.dbo['created_at']);
        this.ipAddress = this.dbo['ip_address'];
        this.isProcessed = this.dbo['is_processed'] == 1;
        this.tendantFK = this.dbo['tendant_id_FK'];
        
        // Determine form type based on formName
        this.isQuoteRequest = this.formName === 'Offerte formulier';

        // For overview display
        this.statusIcon = this.getStatusIcon();
        this.type = 'contact-form';
        this.tabID = this.id;
        this.tabDescription = this.name + (this.isQuoteRequest && this.quoteType ? ' - ' + this.quoteType : '');
    }

    getStatusIcon() {
        if (this.isProcessed) {
            return "fa fa-check-circle green fa-05x";
        }
        return "fa fa-envelope yellow fa-05x";
    }
}

export default ContactFormSubmission;
